import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_mof_item_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  coupon_hdr_guid: fromDatatype.GuidDataFieldInterface;
  txn_class: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  sub_item_type: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  code_alias_json: fromDatatype.JsonDatatypeInterface;
  alt_item_code_01: fromDatatype.VarcharDatatypeInterface;
  alt_item_code_02: fromDatatype.VarcharDatatypeInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  charges_01: fromDatatype.VarcharDatatypeInterface;
  charges_02: fromDatatype.VarcharDatatypeInterface;
  charges_03: fromDatatype.VarcharDatatypeInterface;
  charges_04: fromDatatype.VarcharDatatypeInterface;
  charges_05: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  gl_code_guid: fromDatatype.GuidDataFieldInterface;
  gl_code_name: fromDatatype.VarcharDatatypeInterface;
  min_amount: fromDatatype.BigIntegerDatatypeInterface;
  max_amount: fromDatatype.BigIntegerDatatypeInterface;
}

export class bl_aat_mof_item_hdr_RowClass implements bl_aat_mof_item_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  coupon_hdr_guid: fromDatatype.GuidDataFieldInterface;
  txn_class: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  sub_item_type: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  code_alias_json: fromDatatype.JsonDatatypeInterface;
  alt_item_code_01: fromDatatype.VarcharDatatypeInterface;
  alt_item_code_02: fromDatatype.VarcharDatatypeInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  charges_01: fromDatatype.VarcharDatatypeInterface;
  charges_02: fromDatatype.VarcharDatatypeInterface;
  charges_03: fromDatatype.VarcharDatatypeInterface;
  charges_04: fromDatatype.VarcharDatatypeInterface;
  charges_05: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  gl_code_guid: fromDatatype.GuidDataFieldInterface;
  gl_code_name: fromDatatype.VarcharDatatypeInterface;
  min_amount: fromDatatype.BigIntegerDatatypeInterface;
  max_amount: fromDatatype.BigIntegerDatatypeInterface;
}
